// extracted by mini-css-extract-plugin
module.exports = {"base":"TopNavigationMenu_base__28SKk","menuButton":"TopNavigationMenu_menu-button__2ShQo","open":"TopNavigationMenu_open__2V-rh"};